// OPS Occult Library comparative visual archive v10 — Amniomancy source pack.
(()=>{
  const TITLE_FRAGMENT='amniomancy';
  const SOURCES=[
    {
      date:'1575',period:'Late 16th century',creator:'Cornelius Gemma (1535–1579); woodcut cutter not identified',
      work:'Illustration of a “Caul”, from De naturae divinis characterismis',
      page:'Wellcome image L0006351; plate/page not stated in catalogue record',
      institution:'Wellcome Collection, London',collection:'De naturae divinis characterismis (Antwerp: Christophe Plantin, 1575)',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Illustration_of_a_%22Caul%22%2C_Cornelius_Gemma%2C_16th_Century_Wellcome_L0006351.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Illustration_of_a_%22Caul%22,_Cornelius_Gemma,_16th_Century_Wellcome_L0006351.jpg',
      rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
      attribution:'Cornelius Gemma, Illustration of a “Caul”, De naturae divinis characterismis, Antwerp, 1575. Wellcome Collection image L0006351. CC BY 4.0.',
      medium:'Woodcut book illustration',process:'Relief print from a cut woodblock',material:'Printing ink on paper',colour:'Monochrome',
      visual:'Two compact figures isolate the membrane and the veiled infant. Heavy contour, short parallel hatching and labelled figures make the caul readable as a distinct physical covering.',
      note:'Direct historical visual evidence for the physical phenomenon associated with amniomancy.',verifiedOn:'2026-09-14'
    },
    {
      date:'1759',period:'Mid-18th century',creator:'Johann Georg Roederer (1726–1763)',
      work:'Tab. I: Amniotic sac, from Icones uteri humani observationibus illustratae',
      page:'Tab. I; one of seven fold-out engraved plates',institution:'Wellcome Collection, London',
      collection:'Johann Georg Roederer, Icones uteri humani observationibus illustratae, Göttingen, 1759',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Tab_I%3B_Amniotic_sac_Wellcome_L0064772.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Tab_I%3B_Amniotic_sac_Wellcome_L0064772.jpg',
      rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
      attribution:'Johann Georg Roederer, Tab. I: Amniotic sac, Icones uteri humani observationibus illustratae, 1759. Wellcome Collection image L0064772. CC BY 4.0.',
      medium:'Engraved anatomical plate',process:'Intaglio engraving',material:'Printing ink on paper',colour:'Monochrome',
      visual:'Fine contour, close hatching and sectional detail separate membrane, sac and surrounding structures with clinical precision.',
      note:'Comparative anatomical evidence, not a depiction of divination itself.',verifiedOn:'2026-09-14'
    },
    {
      date:'1888',period:'Late 19th century',creator:'Barton Cooke Hirst (1861–1935); individual illustrator not identified',
      work:'Placenta and membranes during the third stage of labour, from A system of obstetrics',
      page:'Vol. 1, p. 630, Fig. 266',institution:'Yale University, Cushing/Whitney Medical Library',
      collection:'Barton Cooke Hirst, A system of obstetrics, Philadelphia: Lea Brothers & Co., 1888',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/A_system_of_obstetrics_%281888%29_%2814776758174%29.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:A_system_of_obstetrics_(1888)_(14776758174).jpg',
      rights:'No known copyright restrictions; historical 1888 work digitised through Flickr Commons / Internet Archive Book Images',rightsUrl:'https://www.flickr.com/commons/usage/',
      attribution:'Barton Cooke Hirst, A system of obstetrics, vol. 1, 1888, p. 630, Fig. 266. Yale Cushing/Whitney Medical Library / Internet Archive Book Images.',
      medium:'Printed obstetric book illustration',process:'Black-and-white line and tonal reproduction; exact print process not stated',material:'Printing ink on paper',colour:'Monochrome',
      visual:'A clinical diagram reduces membranes and placental attachment to clear outlined forms and sparse shading, prioritising anatomical relationships over pictorial drama.',
      note:'Comparative anatomical context, not a depiction of amniomancy itself.',verifiedOn:'2026-09-14'
    }
  ];

  const key=(v)=>String(v||'').trim().toLowerCase();
  const nudge=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v10-ready');
    target.appendChild(marker); marker.remove();
  };
  const install=()=>{
    const entries=window.OPS_OCCULT_EDITORIAL?.entries;
    if(!Array.isArray(entries)) return false;
    const entry=entries.find((item)=>key(item?.title).includes(TITLE_FRAGMENT) || key(item?.slug).includes(TITLE_FRAGMENT));
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudge();
    return true;
  };
  if(!install()){
    document.addEventListener('DOMContentLoaded',()=>{
      if(install()) return;
      let attempts=0;
      const timer=setInterval(()=>{ attempts+=1; if(install()||attempts>=20) clearInterval(timer); },250);
    },{once:true});
  }
})();
